import {
  Box,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import "../../styles/Home.css";
import logo from "../../Assets/logo.png";
import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <>
      <Container
        maxWidth="lg"
        sx={{
          maxWidth: {
            xs: "100%", // For extra-small screens, full width
            sm: "90%", // For small screens
            md: "83%", // For medium screens
            lg: "83%", // For large screens
            xl: "75%", // For extra-large screens
          },
        }}
      >
        <Box pb={2}>
          <Grid container spacing={0}>
            <Grid xs={12} sm={12} md={12} align="left">
              <Divider sx={{ mb: 5 }} />
            </Grid>

            <Grid
              xs={12}
              sm={3}
              md={3}
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "start", md: "start" },
              }}
            >
              <Box
                component="img"
                src={logo}
                sx={{
                  pt: { xs: 0.5, sm: 2, md: 0.5 },
                  width: { xs: 170, sm: 140, md: 170 },
                  height: 40,
                }}
              />
            </Grid>

            <Grid
              xs={12}
              sm={3}
              md={3}
              pt={{ xs: 3, md: 0 }}
              align="left"
              sx={{ display: { xs: "none", sm: "block", md: "block" } }}
            >
              <Stack direction="row" spacing={{ xs: 10, md: 20 }}>
                <Stack direction="column" spacing={{ xs: 1, md: 1 }}>
                  <Typography
                    variant="paragraph"
                    sx={{ alignSelf: "left", fontFamily: "Roboto" }}
                    fontWeight={500}
                    fontSize={{ xs: "15px", md: "18px" }}
                    color="#1662A7"
                  >
                    QUICK LINKS
                  </Typography>

                  <NavLink
                    to="/2024"
                    exact
                    style={({ isActive }) => ({
                      textDecoration: isActive ? "underline" : "none",
                      color: isActive ? "#1662A7" : "#6E6B7B",
                      height: "25px",
                    })}
                  >
                    <Typography
                      variant="paragraph"
                      sx={{
                        alignSelf: "left",
                        fontFamily: "Roboto",
                        letterSpacing: "1px",
                      }}
                      fontWeight={450}
                      fontSize={{ xs: "14px", md: "14px" }}
                    >
                      Home
                    </Typography>
                  </NavLink>

                  <NavLink
                    to="/2024/aboutus"
                    exact
                    style={({ isActive }) => ({
                      textDecoration: isActive ? "underline" : "none",
                      color: isActive ? "#1662A7" : "#6E6B7B",
                      height: "25px",
                    })}
                  >
                    <Typography
                      variant="paragraph"
                      sx={{
                        alignSelf: "left",
                        fontFamily: "Roboto",
                        letterSpacing: "1px",
                      }}
                      fontWeight={450}
                      fontSize={{ xs: "14px", md: "14px" }}
                    >
                      About
                    </Typography>
                  </NavLink>

                  <NavLink
                    to="/2024/features"
                    exact
                    style={({ isActive }) => ({
                      textDecoration: isActive ? "underline" : "none",
                      color: isActive ? "#1662A7" : "#6E6B7B",
                      height: "25px",
                    })}
                  >
                    <Typography
                      variant="paragraph"
                      sx={{
                        alignSelf: "left",
                        fontFamily: "Roboto",
                        letterSpacing: "1px",
                      }}
                      fontWeight={450}
                      fontSize={{ xs: "14px", md: "14px" }}
                    >
                      Features
                    </Typography>
                  </NavLink>

                  <NavLink
                    to="/2024/patners"
                    exact
                    style={({ isActive }) => ({
                      textDecoration: isActive ? "underline" : "none",
                      color: isActive ? "#1662A7" : "#6E6B7B",
                      height: "25px",
                    })}
                  >
                    <Typography
                      variant="paragraph"
                      sx={{
                        alignSelf: "left",
                        fontFamily: "Roboto",
                        letterSpacing: "1px",
                      }}
                      fontWeight={450}
                      fontSize={{ xs: "14px", md: "14px" }}
                    >
                      Partners
                    </Typography>
                  </NavLink>
                </Stack>
              </Stack>
            </Grid>

            {/* small screen */}
            <Grid
              xs={12}
              sm={3}
              md={3}
              pt={{ xs: 3, md: 0 }}
              align="center"
              sx={{ display: { xs: "block", sm: "none", md: "none" } }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                }}
              >
                <Stack pl={3} direction="row" spacing={{ xs: 10, md: 20 }}>
                  <Stack direction="column" spacing={{ xs: 1, md: 1 }}>
                    <Typography
                      variant="paragraph"
                      align="center"
                      sx={{ alignSelf: "center", fontFamily: "Roboto" }}
                      fontWeight={500}
                      fontSize={{ xs: "15px", md: "17px" }}
                      color="#1662A7"
                    >
                      QUICK LINKS
                    </Typography>

                    <NavLink
                      to="/2024"
                      exact
                      style={({ isActive }) => ({
                        textDecoration: isActive ? "underline" : "none",
                        color: isActive ? "#1662A7" : "#6E6B7B",
                        height: "25px",
                      })}
                    >
                      <Typography
                        variant="paragraph"
                        align="center"
                        sx={{
                          alignSelf: "center",
                          fontFamily: "Roboto",
                          letterSpacing: "1px",
                        }}
                        fontWeight={450}
                        fontSize={{ xs: "14px", md: "14px" }}
                      >
                        Home
                      </Typography>
                    </NavLink>

                    <NavLink
                      to="/2024/aboutus"
                      exact
                      style={({ isActive }) => ({
                        textDecoration: isActive ? "underline" : "none",
                        color: isActive ? "#1662A7" : "#6E6B7B",
                        height: "25px",
                      })}
                    >
                      <Typography
                        variant="paragraph"
                        align="center"
                        sx={{
                          alignSelf: "center",
                          fontFamily: "Roboto",
                          letterSpacing: "1px",
                        }}
                        fontWeight={450}
                        fontSize={{ xs: "14px", md: "14px" }}
                      >
                        About
                      </Typography>
                    </NavLink>

                    <NavLink
                      to="/2024/features"
                      exact
                      style={({ isActive }) => ({
                        textDecoration: isActive ? "underline" : "none",
                        color: isActive ? "#1662A7" : "#6E6B7B",
                        height: "25px",
                      })}
                    >
                      <Typography
                        variant="paragraph"
                        align="center"
                        sx={{
                          alignSelf: "center",
                          fontFamily: "Roboto",
                          letterSpacing: "1px",
                        }}
                        fontWeight={450}
                        fontSize={{ xs: "14px", md: "14px" }}
                      >
                        Features
                      </Typography>
                    </NavLink>

                    <NavLink
                      to="/2024/patners"
                      exact
                      style={({ isActive }) => ({
                        textDecoration: isActive ? "underline" : "none",
                        color: isActive ? "#1662A7" : "#6E6B7B",
                        height: "25px",
                      })}
                    >
                      <Typography
                        variant="paragraph"
                        align="center"
                        sx={{
                          alignSelf: "center",
                          fontFamily: "Roboto",
                          letterSpacing: "1px",
                        }}
                        fontWeight={450}
                        fontSize={{ xs: "14px", md: "14px" }}
                      >
                        Partners
                      </Typography>
                    </NavLink>

                    <Box pt={3}>
                      <Stack direction="column" spacing={{ xs: 1, md: 1 }}>
                        <Typography
                          variant="paragraph"
                          align="center"
                          sx={{ alignSelf: "center", fontFamily: "Roboto" }}
                          fontWeight={500}
                          fontSize={{ xs: "15px", md: "17px" }}
                          color="#1662A7"
                        >
                          OTHER
                        </Typography>

                        <NavLink
                          to="/2024/security"
                          exact
                          style={({ isActive }) => ({
                            textDecoration: isActive ? "underline" : "none",
                            color: isActive ? "#1662A7" : "#6E6B7B",
                            height: "25px",
                          })}
                        >
                          <Typography
                            variant="paragraph"
                            align="center"
                            sx={{
                              alignSelf: "center",
                              fontFamily: "Roboto",
                              letterSpacing: "1px",
                            }}
                            fontWeight={450}
                            fontSize={{ xs: "14px", md: "14px" }}
                          >
                            Security & Compliance
                          </Typography>
                        </NavLink>

                        <NavLink
                          to="/2024/pricing"
                          exact
                          style={({ isActive }) => ({
                            textDecoration: isActive ? "underline" : "none",
                            color: isActive ? "#1662A7" : "#6E6B7B",
                            height: "25px",
                          })}
                        >
                          <Typography
                            variant="paragraph"
                            align="center"
                            sx={{
                              alignSelf: "center",
                              fontFamily: "Roboto",
                              letterSpacing: "1px",
                            }}
                            fontWeight={450}
                            fontSize={{ xs: "14px", md: "14px" }}
                          >
                            Pricing Plans
                          </Typography>
                        </NavLink>

                        <NavLink
                          to="/2024/privacy"
                          exact
                          style={({ isActive }) => ({
                            textDecoration: isActive ? "underline" : "none",
                            color: isActive ? "#1662A7" : "#6E6B7B",
                            height: "25px",
                          })}
                        >
                          <Typography
                            variant="paragraph"
                            align="center"
                            sx={{
                              alignSelf: "center",
                              fontFamily: "Roboto",
                              letterSpacing: "1px",
                            }}
                            fontWeight={450}
                            fontSize={{ xs: "14px", md: "14px" }}
                          >
                            Privacy Policy
                          </Typography>
                        </NavLink>

                        <NavLink
                          to="/2024/terms"
                          exact
                          style={({ isActive }) => ({
                            textDecoration: isActive ? "underline" : "none",
                            color: isActive ? "#1662A7" : "#6E6B7B",
                            height: "25px",
                          })}
                        >
                          <Typography
                            variant="paragraph"
                            align="center"
                            sx={{
                              alignSelf: "center",
                              fontFamily: "Roboto",
                              letterSpacing: "1px",
                            }}
                            fontWeight={450}
                            fontSize={{ xs: "14px", md: "14px" }}
                          >
                            Terms & Conditions
                          </Typography>
                        </NavLink>
                      </Stack>
                    </Box>

                    <Box pt={3}>
                      <Stack direction="column" spacing={{ xs: 1, md: 1 }}>
                        <Typography
                          variant="paragraph"
                          align="center"
                          sx={{ alignSelf: "center", fontFamily: "Roboto" }}
                          fontWeight={500}
                          fontSize={{ xs: "15px", md: "17px" }}
                          color="#1662A7"
                        >
                          CONTACT US
                        </Typography>

                        <NavLink
                          to="/2024/contact"
                          exact
                          style={({ isActive }) => ({
                            textDecoration: isActive ? "underline" : "none",
                            color: isActive ? "#1662A7" : "#6E6B7B",
                            height: "25px",
                          })}
                        >
                          <Typography
                            variant="paragraph"
                            align="center"
                            sx={{
                              alignSelf: "center",
                              fontFamily: "Roboto",
                              letterSpacing: "1px",
                            }}
                            fontWeight={450}
                            fontSize={{ xs: "14px", md: "14px" }}
                          >
                            Contact Support
                          </Typography>
                        </NavLink>
                      </Stack>
                    </Box>

                    {/* <Box pt={3}>
                                            <Stack direction="column" spacing={{ xs: 1, md: 1 }}>
                                                <Typography variant="paragraph" sx={{ alignSelf: "left", fontFamily: "Roboto" }} fontWeight={500} fontSize={{ xs: "15px", md: "17px" }} color="#1662A7">
                                                    SOCIAL
                                                </Typography>

                                                <div style={{ display: "flex", justifyContent: "center", alignContent: "center" }}>
                                                    <Stack align="center" direction="row" spacing={{ xs: 1, md: 3 }}>
                                                        <div> <Box component="img" src={facebook} sx={{ alignSelf: "center", width: { xs: "10px", md: "15px" } }} /></div>
                                                        <div>  <Box component="img" src={twitter} sx={{ alignSelf: "center", width: { xs: "25px", md: "35px" } }} /></div>
                                                        <div>  <Box component="img" src={youtube} sx={{ alignSelf: "center", width: { xs: "25px", md: "35px" } }} /></div>
                                                    </Stack>
                                                </div>

                                            </Stack>
                                        </Box> */}
                  </Stack>
                </Stack>
              </div>
            </Grid>

            <Grid
              xs={12}
              sm={3.5}
              md={3}
              pt={{ xs: 3, md: 0 }}
              align="left"
              sx={{ display: { xs: "none", sm: "block", md: "block" } }}
            >
              <Stack direction="row" spacing={{ xs: 10, md: 20 }}>
                <Stack direction="column" spacing={{ xs: 1, md: 1 }}>
                  <Typography
                    variant="paragraph"
                    sx={{ alignSelf: "left", fontFamily: "Roboto" }}
                    fontWeight={500}
                    fontSize={{ xs: "15px", md: "17px" }}
                    color="#1662A7"
                  >
                    OTHER
                  </Typography>

                  <NavLink
                    to="/2024/security"
                    exact
                    style={({ isActive }) => ({
                      textDecoration: isActive ? "underline" : "none",
                      color: isActive ? "#1662A7" : "#6E6B7B",
                      height: "25px",
                    })}
                  >
                    <Typography
                      variant="paragraph"
                      sx={{
                        alignSelf: "left",
                        fontFamily: "Roboto",
                        letterSpacing: "1px",
                      }}
                      fontWeight={450}
                      fontSize={{ xs: "14px", md: "14px" }}
                    >
                      Security & Compliance
                    </Typography>
                  </NavLink>

                  <NavLink
                    to="/2024/pricing"
                    exact
                    style={({ isActive }) => ({
                      textDecoration: isActive ? "underline" : "none",
                      color: isActive ? "#1662A7" : "#6E6B7B",
                      height: "25px",
                    })}
                  >
                    <Typography
                      variant="paragraph"
                      sx={{
                        alignSelf: "left",
                        fontFamily: "Roboto",
                        letterSpacing: "1px",
                      }}
                      fontWeight={450}
                      fontSize={{ xs: "14px", md: "14px" }}
                    >
                      Pricing Plans
                    </Typography>
                  </NavLink>

                  <NavLink
                    to="/2024/privacy"
                    exact
                    style={({ isActive }) => ({
                      textDecoration: isActive ? "underline" : "none",
                      color: isActive ? "#1662A7" : "#6E6B7B",
                      height: "25px",
                    })}
                  >
                    <Typography
                      variant="paragraph"
                      sx={{
                        alignSelf: "left",
                        fontFamily: "Roboto",
                        letterSpacing: "1px",
                      }}
                      fontWeight={450}
                      fontSize={{ xs: "14px", md: "14px" }}
                    >
                      Privacy Policy
                    </Typography>
                  </NavLink>

                  <NavLink
                    to="/2024/terms"
                    exact
                    style={({ isActive }) => ({
                      textDecoration: isActive ? "underline" : "none",
                      color: isActive ? "#1662A7" : "#6E6B7B",
                      height: "25px",
                    })}
                  >
                    <Typography
                      variant="paragraph"
                      sx={{
                        alignSelf: "left",
                        fontFamily: "Roboto",
                        letterSpacing: "1px",
                      }}
                      fontWeight={450}
                      fontSize={{ xs: "14px", md: "14px" }}
                    >
                      Terms & Conditions
                    </Typography>
                  </NavLink>
                </Stack>
              </Stack>
            </Grid>

            <Grid
              xs={12}
              sm={2.5}
              md={3}
              pt={{ xs: 3, md: 0 }}
              align="left"
              sx={{ display: { xs: "none", sm: "block", md: "block" } }}
            >
              <Stack direction="row" spacing={{ xs: 10, md: 20 }}>
                <Stack direction="column" spacing={{ xs: 1, md: 1 }}>
                  <Typography
                    variant="paragraph"
                    sx={{ alignSelf: "left", fontFamily: "Roboto" }}
                    fontWeight={500}
                    fontSize={{ xs: "15px", md: "17px" }}
                    color="#1662A7"
                  >
                    CONTACT US
                  </Typography>

                  <NavLink
                    to="/2024/contact"
                    exact
                    style={({ isActive }) => ({
                      textDecoration: isActive ? "underline" : "none",
                      color: isActive ? "#1662A7" : "#6E6B7B",
                      height: "25px",
                    })}
                  >
                    <Typography
                      variant="paragraph"
                      sx={{
                        alignSelf: "left",
                        fontFamily: "Roboto",
                        letterSpacing: "1px",
                      }}
                      fontWeight={450}
                      fontSize={{ xs: "14px", md: "14px" }}
                    >
                      Contact Support
                    </Typography>
                  </NavLink>
                </Stack>
              </Stack>
            </Grid>

            {/* <Grid xs={12} sm={3} md={2.4} pt={{ xs: 3, md: 0 }} align="left" sx={{ display: { xs: "none", sm: "block", md: "block" } }}>
                            <Stack direction="row" spacing={{ xs: 10, md: 20 }}>
                                <Stack direction="column" spacing={2}>
                                    <Typography variant="paragraph" sx={{ alignSelf: "left", fontFamily: "Roboto" }} fontWeight={500} fontSize={{ xs: "15px", md: "17px" }} color="#1662A7">
                                        SOCIAL
                                    </Typography>

                                    <Stack direction="row" spacing={{ xs: 1, md: 3 }}>
                                        <div> <Box component="img" src={facebook} sx={{ width: { xs: "10px", md: "15px" } }} /></div>
                                        <div>  <Box component="img" src={twitter} sx={{ width: { xs: "25px", md: "35px" } }} /></div>
                                        <div>  <Box component="img" src={youtube} sx={{ width: { xs: "25px", md: "35px" } }} /></div>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Grid> */}

            <Grid xs={12} md={12} pt={5} align="left">
              <Box pr={{ xs: 5, md: 11 }}>
                <Divider />
              </Box>
            </Grid>

            <Grid xs={12} md={12} pt={2} align="center">
              <Typography
                variant="paragraph"
                sx={{
                  alignSelf: "center",
                  fontFamily: "Roboto",
                  letterSpacing: "1px",
                }}
                fontWeight={400}
                fontSize={{ xs: "14px", md: "15px" }}
                color="#6E6B7B"
              >
                © 2025 RequireSign | All Rights Reserved
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
}

export default Footer;
